<template>
  <div class="loading">
    <bounce-loader :loading="true" :size="'100px'" :color="'black'" class="spinner" />
  </div>
</template>
<style>
  .loading {
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    background-color: gray;
    opacity: 0.3;
  }

  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
  }
</style>
<script>
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'
export default {
  name: 'Spiner',
  components: {
    BounceLoader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/Spiner.vue